import useABTestValue from '@hooks/useABTestValue'

export type UseIsGrowthbookDevModeEnabled = () => boolean

const useIsGrowthbookDevModeEnabled: UseIsGrowthbookDevModeEnabled = () =>
  useABTestValue('enableGrowthBookDevMode') === 'enable'

export default useIsGrowthbookDevModeEnabled
